import { render } from "./Loader.vue?vue&type=template&id=2a1448c5&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=2a1448c5&lang=scss&scoped=true"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1448c5"]])

export default __exports__